import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import common_en from '../locales/en/translation.json'

i18n.use(initReactI18next)
    .use(Backend)
    .init({
        resources: {
            en: {
                translation: common_en
            }
        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        debug: true,
        loadPath: './translations/{{lng}}.json'
    })

export default i18n
